const BranchData = [
    { value: 'Branch-1', label: 'Branch-1', color: '#00B8D9', isFixed: true },
    { value: 'Branch-2', label: 'Branch-2', color: '#0052CC', isFixed: true },
    { value: 'Branch-3', label: 'Branch-3', color: '#5243AA' },
    { value: 'Branch-4', label: 'Branch-4', color: '#FFC400' },
    { value: 'Branch-5', label: 'Branch-5', color: '#36B37E' },
    { value: 'Branch-6', label: 'Branch-6', color: '#00875A' },
    { value: 'Branch-7', label: 'Branch-7', color: '#253858' },
    { value: 'Branch-8', label: 'Branch-8', color: '#666666' },
    { value: 'Branch-9', label: 'Branch-9', color: '#FF5630', isFixed: true },
    { value: 'Branch-10', label: 'Branch-10', color: '#FF8B00' },
];
export default BranchData;